export const dynamicLightFrameIntervalMs = 50
export const dynamicLightSendFrameRate = 1000 / dynamicLightFrameIntervalMs
